export default __webpack_public_path__ + "static/media/security_on_ff2u.420721cb.svg";